/**
 * Whole-page navigation for the demo gate (task 405), in a module of its own
 * so tests can observe it: jsdom's `location` cannot be replaced or spied on.
 */
export function loadPage(url: string, { replace = false } = {}): void {
  if (replace) window.location.replace(url);
  else window.location.assign(url);
}
